export default function generateURL(baseURL, modifyFunc) {
  const url = new URL(baseURL);
  modifyFunc(url.searchParams);
  return url.href;
}
